import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMapPinFlat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMapPinFlat"><Path d="M11.5 6.5H7.5M20.5 11.5V20.5H5C3.61929 20.5 2.5 19.3807 2.5 18M5 15.5H7M5 15.5C3.61929 15.5 2.5 16.6193 2.5 18M5 15.5H7.5V3.5H5C3.61929 3.5 2.5 4.61929 2.5 6V18M20.5 6.92857C20.5 9.78571 17 11.5 17 11.5C17 11.5 13.5 9.78571 13.5 6.92857C13.5 5.03502 15.067 3.5 17 3.5C18.933 3.5 20.5 5.03502 20.5 6.92857Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMapPinFlat;
